export class BoatWidgetShim {
  init = (config) => {
    console.log("init", config);
    this.config = config;

    this.mountIframe();
  };
  mountIframe = () => {
    const iframe = document.createElement("iframe");
    iframe.onload = () => {
      this.iframe.contentWindow.postMessage({
        type: "INIT_IFRAME",
        value: { clientId: this.config.clientId },
      });
    };
    iframe.src =
      this.config.apiUrl +
      "/widget/booking/" +
      this.config.clientId +
      "?config=" +
      encodeURIComponent(JSON.stringify(this.config));
    iframe.crossorigin = "anonymous";

    iframe.style.width = "100%";
    iframe.style.height = "100%";

    this.iframe = iframe;
    window.addEventListener("message", this.receiveMessage, false);
    var embedDiv = document.getElementById(this.config.divId);
    embedDiv.appendChild(this.iframe);
  };

  receiveMessage = (event) => {
    switch (event.data.type) {
      case "resize":
        console.log("resize", event.data);
        const heightWithPadding = Math.round(event.data.height * 1.2);
        console.log("heightWithPadding", heightWithPadding);
        document.getElementById(this.config.divId).style.height = `${heightWithPadding}px`;
        break;
      case "booking_error":
        // If host provided an error callback, pass through errors; otherwise alert
        if (this.config.onErrors && typeof this.config.onErrors === "function") {
          try {
            this.config.onErrors(event.data.value?.errors || []);
          } catch (e) {
            // Fallback alert if callback throws
            const errs = (event.data.value?.errors || []).join("\n");
            console.log("Fallback alert", errs);
            if (errs) alert("Details incomplete: \n" + errs);
          }
        } else {
          const errs = (event.data.value?.errors || []).join("\n");
          if (errs) alert("Details incomplete: \n" + errs);
        }
        break;
      case "quote_complete":
        if (this.config.onQuoteComplete) {
          this.config.onQuoteComplete();
        }
        break;
      case "onInputChange":
          if (this.config.onInputChange && typeof this.config.onInputChange === 'function') {
            try {
              this.config.onInputChange(event.data.value);
            } catch (e) {
              console.log("Error calling onInputChange", e);
            }
          }
          break;
      case "qantas_earn_rate":
        if (this.config.onQantasEarnRate && typeof this.config.onQantasEarnRate === "function") {
          try {
            this.config.onQantasEarnRate(event.data.value);
          } catch (e) {
            console.log("Error calling onQantasEarnRate", e);
          }
        }
        break;
      case "booking_complete":
        if (this.config.onBookingComplete) {
          this.config.onBookingComplete(event.data);
        }
        break;
      case "widget_analytics":
        console.log("[WidgetShim] received widget_analytics", event.data.value);
        if (this.config.onWidgetAnalytics && typeof this.config.onWidgetAnalytics === "function") {
          console.log("[WidgetShim] forwarding onWidgetAnalytics callback");
          this.config.onWidgetAnalytics(event.data.value);
        } else {
          console.log("[WidgetShim] onWidgetAnalytics callback missing");
        }
        break;
      case "scroll_to": {
        const selector = event.data.value && event.data.value.selector;
        if (!selector) {
          break;
        }
        const target = document.querySelector(selector);
        const scrolled = !!(target && typeof target.scrollIntoView === "function");
        if (scrolled) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        if (event.source && typeof event.source.postMessage === "function") {
          const fallbackUrl = new URL(window.location.href);
          fallbackUrl.hash = selector.startsWith("#") ? selector.slice(1) : selector;
          event.source.postMessage(
            {
              type: "scroll_to_ack",
              value: { selector, scrolled, fallbackUrl: fallbackUrl.toString() },
            },
            "*"
          );
        }
        break;
      }
    }
  };
}
export default ((window) => {
  const stubSdk = window && window.boatWidget;

  if (!stubSdk || !stubSdk._c) {
    return;
  }

  const initCall = stubSdk._c.filter((call) => call[0] === "init");

  const shim = new BoatWidgetShim();
  stubSdk.init = shim.init;
  initCall && shim.init(initCall[0][1][0]);
})(global);
